import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';

@Component({
  selector: 'app-collabo-portal-dxsales-change-password-sent',
  templateUrl: './collabo-portal-dxsales-change-password-sent.component.html',
  styleUrls: ['./collabo-portal-dxsales-change-password-sent.component.css',
    '../style/global.css',]
})
export class CollaboPortalDxsalesChangePasswordSentComponent implements OnInit {
  email: string;
  @Input()
  clientId: string;
  constructor(
    public title: Title
  ) {
    title.setTitle('パスワード再設定 メール送信完了');
  }

  ngOnInit(): void {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  async passwordReset() {
    location.pathname = 'forgot-password';
  }

  async toLogin() {
    location.pathname = 'login';
  }

}
